// Utility function to get stock urgency badge
export const getStockUrgencyBadge = (inventoryQuantity) => {
  // Default (hide badge) for products without inventory set or with plenty of stock
  const hidden = {
    show: false,
    type: 'normal',
    text: 'In Stock',
    className: '',
    urgent: false,
  };

  if (inventoryQuantity === null || inventoryQuantity === undefined) return hidden;
  
  if (inventoryQuantity === 0) {
    return {
      show: true,
      type: 'out',
      text: 'Out of Stock',
      className: 'bg-red-500 text-white',
      urgent: true
    };
  }
  
  if (inventoryQuantity <= 5) {
    return {
      show: true,
      type: 'urgent',
      text: `Only ${inventoryQuantity} left!`,
      className: 'bg-red-500 text-white animate-pulse',
      urgent: true
    };
  }
  
  if (inventoryQuantity <= 10) {
    return {
      show: true,
      type: 'low',
      text: `Low Stock - ${inventoryQuantity} left`,
      className: 'bg-yellow-500 text-black',
      urgent: false
    };
  }
  
  return {
    show: false,
    type: 'normal',
    text: 'In Stock',
    className: '',
    urgent: false
  };
};
